import { Box, Container, Typography } from "@mui/material";
import styles from "./styles.module.scss";
import moment from "moment";
import { useBreadcrumbs } from "contexts/breadcrumbContext";
import { useEffect } from "react";
import { Breadcrumb } from "components/core/breadcrumb";
import { Blog } from "types/blogs";
import { ReactComponent as OtlLogo } from "../../../../../otl-logo.svg";

type Props = {
  blog: Blog;
};

export const BlogHero = ({ blog, ...props }: Props) => {
  const publishedAt = moment(blog.publishedAt).format("MMMM DD, YYYY");
  const { updateBreadcrumbs, breadcrumbItems } = useBreadcrumbs();

  useEffect(() => {
    updateBreadcrumbs([
      { label: "Blogs", link: "/blogs" },
      { label: "Blog Details", link: "" },
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {blog && (
        <Box className={styles.hero} {...props}>
          {blog.image && (
            <img
              className={styles.hero__image}
              src={blog.image}
              alt={blog.title.slice(0, 30)}
            />
          )}
          <div className="hero__overlay" />

          <Box
            sx={{
              position: "absolute",
              top: "100px",
              marginBottom: 2,
              width: "100%",
            }}
          >
            <Container maxWidth="lg">
              <Breadcrumb
                breadcrumbs={breadcrumbItems}
                color="var(--lightGray)"
                activeColor="white"
              />
            </Container>
          </Box>

          <Container maxWidth="lg" className={styles.hero__content}>
            <Typography variant="h2">{blog.title}</Typography>
            <Typography variant="h4">{blog.description}</Typography>
            <Box className={styles.hero__footer}>
              <OtlLogo className={styles.otl__logo} />

              <Typography
                variant="body2"
                id="author"
                className={styles.hero__footer__author}
              >
                {blog.source}
              </Typography>
              <Typography variant="body2" id="published-at">
                {publishedAt}
              </Typography>
            </Box>
          </Container>
        </Box>
      )}
    </>
  );
};
